export const trimInput = (input) => input.replace(/^\s+|\s+$/g, '');

export const isUserInProject = (email, projectUsers) =>
  projectUsers.some((user) => user.email === email);

export const isUserInAccount = (email, accountUsers) =>
  accountUsers.some((user) => user.email === email);
